'use strict';

var path = require('path');
var locatePath = require('locate-path');
module.exports = function (filename) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var startDir = path.resolve(opts.cwd || '');
  var _path$parse = path.parse(startDir),
    root = _path$parse.root;
  var filenames = [].concat(filename);
  return new Promise(function (resolve) {
    (function find(dir) {
      locatePath(filenames, {
        cwd: dir
      }).then(function (file) {
        if (file) {
          resolve(path.join(dir, file));
        } else if (dir === root) {
          resolve(null);
        } else {
          find(path.dirname(dir));
        }
      });
    })(startDir);
  });
};
module.exports.sync = function (filename) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var dir = path.resolve(opts.cwd || '');
  var _path$parse2 = path.parse(dir),
    root = _path$parse2.root;
  var filenames = [].concat(filename);

  // eslint-disable-next-line no-constant-condition
  while (true) {
    var file = locatePath.sync(filenames, {
      cwd: dir
    });
    if (file) {
      return path.join(dir, file);
    }
    if (dir === root) {
      return null;
    }
    dir = path.dirname(dir);
  }
};